import { CanActivateFn, CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { UnsavedChangesService } from '../services/unsaved-changes.service';

/**
 * Guard that prevents the user from navigating to another atlas view
 * (`canActivate` on the view routes) or leaving the atlas entirely
 * (`canDeactivate` on the atlas root routes) while the GridStore holds
 * unsaved changes. Shows a confirmation dialog if changes are detected.
 *
 * @return {CanActivateFn | CanDeactivateFn<unknown>} The functional guard.
 */
export const unsavedChangesGuard: CanActivateFn &
  CanDeactivateFn<unknown> = () =>
  inject(UnsavedChangesService).confirmDiscard();
